import "./style.scss";

interface PageProps {
	close: any;
	caption: any;
}

const StoriesCaption = ({ close, caption }: PageProps) => {
	return (
		<div className="stories-caption__container">
			<h3>{caption}</h3>
			<button aria-label="close-popup" onClick={close}>
				Go on, close this popup.
			</button>
		</div>
	);
};

export default StoriesCaption;
